<template>
  <div>
    <div class="lyon-display-medium-24 mb-3">Overview</div>
    <div class="regular-16 mb-3  custom-html-text" v-html = "data.abstract"/>
    <div class="lyon-display-medium-24 mb-3" v-if="data.organizers.length > 0">
      Organizers
    </div>
    <div class="mb-3">
      <organizer
        :organizers="data.organizers"
        :organizers-email-ids="data.organizers_person_email_ids.email_ids"
      />
    </div>
    <div class="lyon-display-medium-24 mb-3" v-if="data.speakers.length > 0">Speakers</div>
    <div class="regular-16 mb-3">
      <speaker :speakers="data.speakers"/>
    </div>
    <div class="lyon-display-medium-24 mb-3 mt-3" v-if="data.primary_ams.length > 0">
      Primary Mathematics Subject Classification
    </div>
    <div style="overflow-x:auto;">
      <primary-mathematics-subject-classification-view :primary="data.primary_ams"/>
    </div>
    <div class="lyon-display-medium-24 mb-3 mt-3" v-if="data.secondary_ams.length > 0">
      Secondary Mathematics Subject Classification
    </div>
    <div style="overflow-x:auto;">
      <secondary-mathematics-subject-classification-view :secondary="data.secondary_ams"/>
    </div>
  </div>
</template>

<script>
import Organizer from '@/components/CommonPages/Organizer.vue'
import Speaker from '@/components/CommonPages/Speaker.vue'
import PrimaryMathematicsSubjectClassificationView from '@/components/CommonPages/PrimaryMathematicsSubjectClassificationView.vue'
import SecondaryMathematicsSubjectClassificationView from '@/components/CommonPages/SecondaryMathematicsSubjectClassificationView.vue'

export default {
  components: { Organizer, Speaker, PrimaryMathematicsSubjectClassificationView, SecondaryMathematicsSubjectClassificationView },
  name: 'OverviewTabSection',
  props: ['data']
}
</script>
